import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TInitialValuesIndicators = {
  isPoll: boolean;
};

const initialState: TInitialValuesIndicators = {
  isPoll: true,
};

export const indicatorsSlice = createSlice({
  name: 'ui/indicators',
  initialState,
  reducers: {
    setIsPoll(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isPoll: payload };
    },
  },
});

const selectIndicators = (state: RootState) => state.ui.indicators;

export const selectors = { selectIndicators };
export const actions = indicatorsSlice.actions;
export const reducer = indicatorsSlice.reducer;
